type EpostButtonProps = { onClick: () => void }

export default function EpostButton(props: EpostButtonProps) {
  return (
    <button className="mt-4 btn-primary" onClick={props.onClick}>
      Send token
    </button>
  )
}
